<template>
  <section class="relative block overflow-hidden">
    <div class="absolute inset-0">
      <nuxt-img class="w-full h-full md-max:object-cover" width="1024" height="787" preload loading="eager" fetchpriority="high" format="webp"
        sizes="xs:340px sm:440px md:768px lg:1024px xl:1024px 2xl:1024px" :src="bgHero" alt="background hero" />
    </div>

    <div class="backdrop-contrast-75">
      <div
        class="relative flex items-center justify-end px-5 py-2 mx-auto sm-max:pt-6 sm-max:px-3 max-w-screen-2xl md:px-7 lg:px-14 xl:px-20 2xl:px-12 lg:items-center">
        <div class="flex-grow block w-14">
          <nuxt-img width="128" height="91" preload class="relative z-20 w-32 pt-4 sm-max:pt-0 sm-max:w-20"
            :src="logoSrc" :alt="logoAlt" />
        </div>
        <a :href="phoneHref"
          class="z-20 flex px-4 py-3 text-white no-underline uppercase border border-solid rounded-full sm-max:px-3 sm-max:text-12 lg:px-6 whitespace-nowrap border-brownLatte underline-offset-4 decoration-brownLatte font-WWebMedium justify-self-end phone hover:underline">{{
            phoneText }}
        </a>
        <button @click="scrollTo(productsId,scrollPosition())"
          class="inline-flex z-[10] sm-max:text-12 font-ww-medium font-bold sm-max:px-3 sm-max:ml-3 ml-6 items-center justify-center px-10 uppercase text-sm lg:text-lg hover:shadow-lg text-center leading-4 bg-black text-white hover:opacity-80 rounded-full py-3.5 xl:py-4 xl:px-9 transition-all">{{
            orderNowText }}</button>
      </div>
      <div
        class="relative z-20 grid max-w-screen-xl px-4 py-8 mx-auto 2xl:px-0 lg:gap-8 xl:gap-0 lg:py-8 lg:grid-cols-12">

        <div class="w-full mr-auto place-self-center lg:col-span-6 lg:py-5">

          <div class="grid">
            <div class="">
              <h2
                class="max-w-xl mt-0 mb-4 text-center text-white h1 sm-max:mx-auto lg:text-left lg:text-46 lg:leading-10 lg:max-w-2xl md:max-w-lg md-max:mx-auto drop-shadow-2xl">
                <span class="inline-block mt-1 font-WWebMedium">
                  <span v-html="subHeading"></span> <b class="relative inline-block"> <nuxt-img width="394" height="62" preload
                      class="absolute z-0 -right-2 -bottom-6 lg:-bottom-10 lg:-right-4" src="/assets/images/line-bottom11.png" alt="line text" />
                    <span class="relative z-10 capitalize"> We'll Refund You!</span></b>
                </span>
              </h2>

              <div class="grid max-w-md grid-cols-12 mt-4 sm-max:mx-auto lg:max-w-56 md:mt-0 md-max:mx-auto lg:mt-8">
                <div v-for="(item, index) in items" :key="index"
                  class="flex flex-col justify-center col-span-4 my-3 gap-y-1 md:my-2">
                  <nuxt-img width="48" height="48" sizes="xs:48px sm:48px md:48px lg:48px xl:48px 2xl:48px" format="webp" preload class="object-contain w-12 h-12 mx-auto" :src="item.imgSrc"
                    :alt="item.text" />
                  <span class="mx-auto text-xs font-medium text-white uppercase font-open-sans">
                    {{ item.text }}
                  </span>
                </div>
              </div>
            </div>
        
          </div>
        </div>

        <div class="grid items-center lg:col-span-6">
          <div class="col-span-12 md:py-0">
            <nuxt-img width="640" height="425" class="object-contain w-full max-w-md mx-auto md:max-w-full md:h-96"
              sizes="xs:330px sm:420px md:450px lg:500px xl:500x 2xl:640px" preload loading="eager" fetchpriority="high" format="webp" :src="srcProduct"
              alt="product" />

            <div class="xl:mt-0 lg:-mt-4">
              <h3 class="text-center text-white textp md:text-xl md:text-center" v-html="smallMainHeading">
              </h3>
              <h1 class="max-w-5xl mx-auto font-bold text-center text-white h4 md:text-center drop-shadow-2xl"
                v-html="mainHeading">
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  bgHero: {
    type: String,
    default: '/assets/images/bg-latte-hero.png'
  },
  logoSrc: {
    type: String,
    default: '/assets/images/logo-white.svg'
  },
  logoAlt: {
    type: String,
    default: 'Lifeboost Coffee Logo'
  },
  phoneHref: {
    type: String,
    default: 'tel:1-800-479-1596'
  },
  phoneText: {
    type: String,
    default: '1-800-479-1596'
  },
  orderNowText: {
    type: String,
    default: 'order now'
  },
  productsId: {
    type: String,
    default: 'the-products'
  },
  smallMainHeading: {
    type: String,
    default: 'INTRODUCING THE'
  },
  mainHeading: {
    type: String,
    default: 'LIFEBOOST LATTE BUNDLE'
  },
  subHeading: {
    type: String,
    default: 'Do THIS Instead Of Breakfast For 15 Days... If You Don\'t Feel A Difference,'
  },
  srcProduct: {
    type: String,
    default: '/assets/images/image3-1.png'
  },
  items: {
    type: Array,
    default: () => [
      {
        imgSrc: '/assets/images/FOCUS-ICON.png',
        text: 'focus'
      },
      {
        imgSrc: '/assets/images/ENERGY-ICON.png',
        text: 'Energy'
      },
      {
        imgSrc: '/assets/images/WELLNESS-ICON.png',
        text: 'WELLNESS'
      },

    ]
  },
})

defineBuilderComponent({
  friendlyName: "Hero-2",
  inputs: [
    {
      name: "bgHero",
      type: "file",
      allowedFileTypes: ["jpeg", "jpg", "svg", "png"],
      defaultValue: "/assets/images/bg-latte-hero.png"
    },
    {
      name: "logoSrc",
      type: "file",
      allowedFileTypes: ["jpeg", "jpg", "svg", "png"],
      defaultValue: "/assets/images/logo-white.svg"
    },
    {
      name: "logoAlt",
      type: "text",
      defaultValue: "Lifeboost Coffee Logo"
    },
    {
      name: "phoneHref",
      type: "text",
      defaultValue: "tel:1-800-479-1596"
    },
    {
      name: "phoneText",
      type: "text",
      defaultValue: "1-800-479-1596"
    },
    {
      name: "orderNowText",
      type: "text",
      defaultValue: "order now"
    },
    {
      name: "productsId",
      type: "text",
      defaultValue: "the-products"
    },
    {
      name: "smallMainHeading",
      type: "richText",
      defaultValue: "INTRODUCING THE"
    },
    {
      name: "mainHeading",
      type: "richText",
      defaultValue: "LIFEBOOST LATTE BUNDLE"
    },
    {
      name: "subHeading",
      type: "richText",
      defaultValue: "Do THIS Instead Of Breakfast For 15 Days... If You Don't Feel A Difference,"
    },
    {
      name: "srcProduct",
      type: "file",
      allowedFileTypes: ["jpeg", "jpg", "svg", "png"],
      defaultValue: "/assets/images/image3-1.png"
    },
    {
      name: "items",
      type: "list",
      subFields: [
        {
          name: "imgSrc",
          type: "file",
          allowedFileTypes: ["jpeg", "jpg", "svg", "png"],
          defaultValue: ""
        },
        {
          name: "text",
          type: "text",
          defaultValue: ""
        }
      ],
      defaultValue: [
        {
          imgSrc: "/assets/images/FOCUS-ICON.png",
          text: "focus"
        },
        {
          imgSrc: "/assets/images/ENERGY-ICON.png",
          text: "Energy"
        },
        {
          imgSrc: "/assets/images/WELLNESS-ICON.png",
          text: "WELLNESS"
        }
      ]
    }
  ]
});
</script>